<template>
    <div :class="$style.root">
        <div class="w">
            <div v-if="newRecommendedlist.length>0">
                <div>
                    <div
                        class="broadcast-box"
                        @click="goVideoDetail(item.media_id)"
                        v-for="(item, index) in newRecommendedlist"
                        :key="index">
                        <div class="broadcast-img">
                            <img :src="baseUrl+item.programId+'/thumbnail.png'" @error="defImg()" />
                        </div>
                        <div class="broadcast-info">
                            <h1 style=" white-space: nowrap;overflow: hidden;">标题：{{ item.media_name }}</h1>
                            <div>类型：{{ item.teacher }}。</div>
                            <div class="time">时长：{{ item.view_duration }}</div>
                            <div class="time">创建时间：{{ item.createtime | createformatTime }}</div>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </div>
                <div class="pagination-box">
                    <a-pagination
                        v-model="current"
                        :page-size-options="pageSizeOptions"
                        :total="newRecomdExtra"
                        :show-total="newRecomdExtra => `共 ${newRecomdExtra} 条`"
                        :page-size="pageSize"
                        @change="hotOnTableChanged">
                        <template slot="buildOptionText" slot-scope="props">
                            <span v-if="props.value !== '50'">{{ props.value }}条/页</span>
                            <span v-if="props.value === '50'">全部</span>
                        </template>
                    </a-pagination>
                </div>
            </div>

            <div style="text-align:center; line-height :100px;" v-else>暂无内容</div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import { mapActions, mapState } from 'vuex';

    export default {
        name: 'CreateTerminologyDialog',
        filters: {
            newformatTime(data) {
                const hours = moment.duration(parseInt(data, 0)).hours();
                const seconds = moment.duration(parseInt(data, 0)).seconds();

                const minutes = moment.duration(parseInt(data, 0)).minutes();

                return `${hours < 10 ? `0${hours}` : hours}:${minutes < 10 ? `0${minutes}` : minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
            },
            createformatTime(data) {
                if (data) return moment(new Date(data)).format('YYYY/MM/DD HH:mm:ss');
                return '';
            },
        },

        data() {
            return {
                pageSizeOptions: ['10', '20', '30', '40', '50'],
                current: 1,
                pageSize: 5,
                total: 10,
                spinning: true,
                baseUrl: '',
                defaultImg: require('../../../assets/LOGO_bg.png'),
            };
        },
        computed: {
            ...mapState('liveVideo', ['liveVideoList']),
            ...mapState('recommend', [
                'videoDetailLoading',
                'videoRecommendedlist',
                'newRecomdQueries',
                'newRecomdExtra',
                'newRecommendedlist',
            ]),
            ...mapState(['userInfo']),
        },
        mounted() {
            this.handNewRecommendedList({});
            const URL = `http://${window.location.host}:8000/`;
            this.baseUrl = URL;
        },

        destroyed() {},

        methods: {
            ...mapActions('recommend', ['getHotVideoList', 'getNewVideoList']),

            // 推荐列表
            handNewRecommendedList(queries) {
                const orgId = this.userInfo.org_id || '';


                const queries1 = {
                    orgId: orgId || '',
                    orderType: '1',
                    currPage: this.current,
                    perPageNum: this.pageSize,
                    channelId: this.channelId,
                    ...queries,
                };
                if (!this.userInfo.org_id) {
                    delete queries1.orgId;
                }
                this
                    .getNewVideoList(queries1)
                    .then(() => {
                        this.spinning = false;
                    })
                    .catch(({ message }) => {
                        if (message) this.$message.error(message);
                    });
            },

            hotOnTableChanged(currPage, perPageNum) {
                const queries = {
                    currPage,
                    perPageNum,
                };


                this.handNewRecommendedList(queries);
            },
            goVideoDetail(mediaId) {
                this.$router.push({ name: 'VideoDetailView', params: { mediaId } });
            },
            defImg() {
                const img = event.srcElement;
                img.src = this.defaultImg;
                img.onerror = null; // 防止闪图
            },
        },
    };
</script>

<style lang="less" module>
    .root {
        max-width: 1200px;
        margin: 20px auto 0;
        height: auto;
        background: #f0f3f9;
        padding-top: 20px;

        :global {
            .w {
                width: 1180px;
                margin: 0 auto;

                .pagination-box {
                    margin: auto;
                }

                .broadcast-box {
                    width: 1180px;
                    height: auto;
                    color: #868d9a;
                    padding: 30px 0;
                    border-bottom: 1px dashed #d3d5db;
                }

                .broadcast-box {
                    width: 1180px;
                    height: auto;
                    color: #868d9a;
                    padding: 30px 0;
                    border-bottom: 1px dashed #d3d5db;
                }

                .broadcast-box:hover {
                    -webkit-transition-property: -webkit-padding-left;
                    transition-property: padding-left;
                    -webkit-transition-duration: 0.5s;
                    transition-duration: 0.5s;
                    -webkit-transition-timing-function: ease;
                    transition-timing-function: ease;
                    width: 1180px;
                    padding-left: 20px;
                    background: #fff;
                }

                .broadcast-img {
                    width: 210px;
                    margin-right: 20px;
                    height: 118px;
                    float: left;
                }

                .broadcast-img img {
                    width: 100%;
                    height: 100%;
                    overflow: hidden;
                }

                .broadcast-info {
                    width: 930px;
                    height: 118px;
                    float: left;
                }

                .broadcast-info h1 {
                    color: #273142;
                    font-size: 18px;
                    font-weight: bold;
                    margin-bottom: 10px;
                    padding-top: 10px;
                    cursor: pointer;
                }

                .broadcast-info p {
                    color: #868d9a;
                    font-size: 14px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                }

                .broadcast-info-line {
                    width: 100%;
                    height: 26px;
                }

                .broadcast-info-line span {
                    display: block;
                    width: 65px;
                    height: 26px;
                    line-height: 26px;
                    float: left;
                }

                .broadcast-info-line i {
                    width: 1px;
                    height: 10px;
                    float: left;
                    margin: 8px 20px 0 0;
                    background: #979eaa;
                }

                .broadcast-info-line .time {
                    color: #868d9a;
                    width: 200px;
                    height: 26px;
                    line-height: 26px;
                    float: left;
                }
            }
        }
    }
</style>
